module.exports = __webpack_public_path__ + "static/media/jo.9e2f2b3a.svg";